/**
 * ONVIF profile counts across the camera models whose datasheet lists them,
 * counted from VISIBLE_SPECS_INDEX. Kept as constants so the /onvif page does
 * not ship the whole index; src/data/__tests__/onvifProfileStats.test.ts
 * recounts the index and fails when these drift.
 */
export const ONVIF_PROFILE_STATS = {
  models: 1079,
  S: 1079,
  T: 967,
  G: 934,
  M: 298,
} as const;

/** The same counts for the brands that have an RTSP guide under /rtsp-url. */
export const ONVIF_PROFILE_STATS_BY_BRAND: Readonly<Record<string, { models: number; S: number; T: number; G: number; M: number }>> = {
  hikvision: { models: 390, S: 390, T: 299, G: 389, M: 48 },
  dahua: { models: 118, S: 118, T: 109, G: 106, M: 17 },
  axis: { models: 20, S: 20, T: 20, G: 20, M: 11 },
};
